import React, { useState } from 'react';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ActivityListPage } from './pages/ActivityListPage';
import { ActivityDetailPage } from './pages/ActivityDetailPage';
import { ActivityFormPage } from './pages/ActivityFormPage';
import { ReportPage } from './pages/ReportPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { ProgressPage } from './pages/ProgressPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { VerificationPage } from './pages/VerificationPage';
import { ProPage } from './pages/ProPage';
import { KontraPage } from './pages/KontraPage';
import { OsintPage } from './pages/OsintPage';
import { AppShell } from './components/AppShell';
import { ToastProvider } from './components/Toast';
import { ConfirmDialog } from './components/ConfirmDialog';
import { mockActivities, currentUser, mockNotifications, mockUsers, mockAuditLogs, mockProTasks, mockKontraTasks, mockOsintTasks } from './data/mockData';
export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [selectedActivityId, setSelectedActivityId] = useState<string | null>(null);
  // Logout confirmation state
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);
  const handleLogin = () => {
    setIsLoggedIn(true);
    setCurrentPage('dashboard');
  };
  const requestLogout = () => {
    setIsLogoutDialogOpen(true);
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setCurrentPage('dashboard');
  };
  const navigateTo = (page: string) => {
    setCurrentPage(page);
    if (page !== 'activity-detail' && page !== 'activity-form') {
      setSelectedActivityId(null);
    }
  };
  const handleViewActivity = (id: string) => {
    setSelectedActivityId(id);
    setCurrentPage('activity-detail');
  };
  const handleAddActivity = () => {
    setSelectedActivityId(null);
    setCurrentPage('activity-form');
  };
  const handleEditActivity = (id: string) => {
    setSelectedActivityId(id);
    setCurrentPage('activity-form');
  };
  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} data-id="element-0" />;
  }
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <DashboardPage activities={mockActivities} onViewActivity={handleViewActivity} data-id="element-1" />;
      case 'activities':
        return <ActivityListPage activities={mockActivities} onViewActivity={handleViewActivity} onAddActivity={handleAddActivity} onEditActivity={handleEditActivity} data-id="element-2" />;
      case 'activity-detail':
        return <ActivityDetailPage activityId={selectedActivityId!} activities={mockActivities} onBack={() => navigateTo('activities')} onEdit={handleEditActivity} data-id="element-3" />;
      case 'activity-form':
        return <ActivityFormPage activity={selectedActivityId ? mockActivities.find(a => a.id === selectedActivityId) : undefined} onSave={() => navigateTo('activities')} onCancel={() => navigateTo(selectedActivityId ? 'activity-detail' : 'activities')} data-id="element-4" />;
      case 'progress':
        return <ProgressPage activities={mockActivities} onViewActivity={handleViewActivity} data-id="element-5" />;
      case 'documents':
        return <DocumentsPage activities={mockActivities} onViewActivity={handleViewActivity} data-id="element-6" />;
      case 'verification':
        return <VerificationPage activities={mockActivities} onViewActivity={handleViewActivity} data-id="element-7" />;
      case 'pro':
        return <ProPage tasks={mockProTasks} data-id="element-8" />;
      case 'kontra':
        return <KontraPage tasks={mockKontraTasks} data-id="element-9" />;
      case 'osint':
        return <OsintPage tasks={mockOsintTasks} data-id="element-10" />;
      case 'reports':
        return <ReportPage activities={mockActivities} data-id="element-11" />;
      case 'users':
        return <UserManagementPage users={mockUsers} data-id="element-12" />;
      case 'audit-log':
        return <AuditLogPage logs={mockAuditLogs} data-id="element-13" />;
      default:
        return <div className="flex items-center justify-center h-full" data-id="element-14">
            <div className="text-center text-gray-500" data-id="element-15">
              <h2 className="text-xl font-semibold mb-2" data-id="element-16">
                Halaman Sedang Dibangun
              </h2>
              <p data-id="element-17">Modul {currentPage} akan segera tersedia.</p>
            </div>
          </div>;
    }
  };
  const unreadNotifications = mockNotifications.filter(n => !n.isRead).length;
  return <ToastProvider data-id="element-18">
      <AppShell activePage={currentPage} onNavigate={navigateTo} onLogout={requestLogout} user={currentUser} notificationCount={unreadNotifications} notifications={mockNotifications} data-id="element-19">
        {renderPage()}
      </AppShell>

      <ConfirmDialog isOpen={isLogoutDialogOpen} title="Konfirmasi Keluar" message="Apakah Anda yakin ingin keluar dari sistem ROSS? Sesi Anda akan diakhiri." confirmText="Keluar" type="danger" onConfirm={handleLogout} onCancel={() => setIsLogoutDialogOpen(false)} data-id="element-20" />
    </ToastProvider>;
}